"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M8 7.60868V13.3917C8 13.9327 8.607 14.2037 8.963 13.8217L12.834 10.9217C13.055 10.6837 13.055 10.2997 12.834 10.0627L8.964 7.17868C8.607 6.79668 8 7.06768 8 7.60868Z",
    fill: "#727B7F"
  }));
};